import { SessionStorageWrapper, LocalStorageWrapper } from '@admin/lib/storage';

/**
 * Utility class to deal with features related to a company session.
 */
class CompanySessionManager {
  public static readonly STORAGE_KEY = 'selected_company_id';

  public static readonly HEADER_KEY = 'X-Company-ID';

  private static sessionStore = new SessionStorageWrapper();

  private static localStore = new LocalStorageWrapper();

  /**
   * Get the company id from session or local store.
   * @returns string | null
   */
  public static getCompanyId(): string | null {
    let companyId = this.sessionStore.getItem(this.STORAGE_KEY) as string | null;

    if (!companyId) {
      companyId = this.getLastCompanyId();
    }

    return companyId;
  }

  public static getCurrentCompanyId(): string | null {
    return this.sessionStore.getItem(this.STORAGE_KEY) as string | null;
  }

  public static getLastCompanyId(): string | null {
    return this.localStore.getItem(this.STORAGE_KEY) as string | null;
  }

  /**
   * Set the company id into the session store and cookie.
   * @returns void
   * @param companyId
   */
  public static setCompany(companyId: number): void {
    this.sessionStore.setItem(this.STORAGE_KEY, companyId);
  }

  public static setLastCompany(companyId: number): void {
    this.localStore.setItem(this.STORAGE_KEY, companyId);
  }

  /**
   * Removes the company from the session and local storage.
   */
  public static removeCompany(): void {
    this.sessionStore.removeItem(this.STORAGE_KEY);
    this.localStore.removeItem(this.STORAGE_KEY);
  }

  public static getHeaderConfig(): Record<string, string> {
    const sessionCompanyId = this.getCompanyId();

    if (sessionCompanyId) {
      return {
        [this.HEADER_KEY]: sessionCompanyId,
      };
    }

    return {};
  }
}

export default CompanySessionManager;
